import * as React from 'react';

const useIsInIframe = () => {
	const [isInIframe, setIsInIframe] = React.useState(false);

	React.useEffect(() => {
		setIsInIframe(window.self !== window.top);
	}, []);

	return isInIframe;
};

export default useIsInIframe;
